import {IMAGE_DEFAULT_FORMATS} from "../../../app/consts";
import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";

export class SchemaLogoImageParams extends AssetsRequestParams {
  constructor(width, height) {
    super({width, height});

    this.resourceName = `${this.resourceName}/Logo/logo_with_bg`;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}
